export enum AppSection {
  OVERVIEW = 'OVERVIEW',
  COURT = 'COURT',
  RULES = 'RULES',
  GEAR = 'GEAR',
  SCORING = 'SCORING',
  GAMES = 'GAMES',
}

export interface QuizQuestion {
  id: number;
  question: string;
  options: string[];
  correctIndex: number;
  explanation: string;
}

export interface RuleModuleData {
  id: string;
  title: string;
  icon: string;
  content: string;
  quiz?: QuizQuestion;
  animationType?: 'serve' | 'rally' | 'none';
}

export enum GameScenarioType {
  FAULT = 'FAULT',
  VALID = 'VALID'
}

export interface FaultScenario {
  id: number;
  description: string;
  type: GameScenarioType;
  feedback: string;
}

export interface GearItem {
  id: string;
  name: string;
  icon: string;
  summary: string;
  description: string;
  lookFor: string[];
  beginnerTip: string;
  essential: boolean;
}
